module.exports = __webpack_public_path__ + "static/img/flowIcon5.7b9ee70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowIcon5.png
// module id = 9K5Z
// module chunks = 1